export default __webpack_public_path__ + "static/media/akhbar.c07b8a4e.mp3";